<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
          <v-card
          >
            <v-card-title>
              Probetraining?
            </v-card-title>
            <v-card-subtitle
              class="pb-0"
            >
              Ihr möchtet Judo mal ausprobieren? Ruft gerne bei unserem 1. Vorsitzenden oder Jugendwart an! Probetrainings sind bei uns kostenlos.
              Bitte denkt an Sportbekleidung (lange Hose + T-Shirt) und genügend zu trinken. Judo machen wir barfuß.
            </v-card-subtitle>
            <v-card-actions
            >
              <v-btn
                class="primary--text ml-2 mt-1"
                outlined
                rounded
                small
                @click="task('dGVsOjAxNTc3NzI3MjQzMA==')"
              >
                <v-icon>
                  mdi-phone
                </v-icon>
                1. Vorsitzender
              </v-btn>
              <v-btn
                class="primary--text ml-2 mt-1"
                outlined
                rounded
                small
                @click="task('dGVsOjAxNTIyOTU2MTM5NA==')"
              >
                <v-icon>
                  mdi-phone
                </v-icon>
                Jugendwart
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-card
        >
          <v-card-title>
            Trainingsplan
          </v-card-title>
          <v-card-subtitle>
            Unser Training findet nur an Schultagen statt. In den Ferien sind die Hallen geschlossen.
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
                :headers="trainingsplan_headers"
                :items="trainingsplanAugmented"
                :items-per-page="-1"
                class="elevation-0"
                disable-sort
                hide-default-footer
            >
              <template v-slot:item.wochentag="{ item }">
                <!-- XS (kleinste Ansicht): immer anzeigen -->
                <span class="d-sm-none">{{ item.wochentag }}</span>
                <!-- Ab SM: nur in der ersten Zeile des Tages -->
                <span class="d-none d-sm-inline">
                  {{ item.isFirstOfDay ? item.wochentag : '' }}
                </span>
              </template>
              <template v-slot:item.ort="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs"
                        v-on="on"
                        small
                        outlined
                        color="primary"
                        style="cursor: pointer"
                        @click="openLocation(item.ort)"
                    >
                      <v-icon left small>mdi-map-marker</v-icon>
                      {{ item.ort }}
                    </v-chip>
                  </template>
                  <span>{{ tooltipFor(item.ort) }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Trainingsplan",
  data() {
    return {
      trainingsplan_headers: [
        {'value': "wochentag", 'text': "Wochentag"},
        {'value': "uhrzeit", 'text': "Uhrzeit"},
        {'value': "zielgruppe", 'text': "Zielgruppe"},
        {'value': "ort", 'text': "Ort"},
        {'value': "trainer", 'text': "Trainer"}
      ],
      traningsplan: [
        {'wochentag':  "Montag", "uhrzeit": "19:00 - 20:30", "zielgruppe": "Jugendliche und Erwachsene", "ort": "IGS / Halle A", "trainer": "Leonard Birkenfeld"},

        {'wochentag':  "Dienstag", "uhrzeit": "14:30 - 16:00", "zielgruppe": "AG - Grundschule Garbsen-Mitte", "ort": "IGS / Halle A", "trainer": "Wolfgang Helfers"},
        {'wochentag':  "Dienstag", "uhrzeit": "16:30 - 18:00", "zielgruppe": "Kinder und Jugendliche", "ort": "IGS / Halle A", "trainer": "Arne Reckhaus"},
        {'wochentag':  "Dienstag", "uhrzeit": "18:30 - 20:00", "zielgruppe": "Jugendliche und Erwachsene", "ort": "IGS / Halle A", "trainer": "Alexander Bannert / Wolfgang Helfers"},

        {'wochentag':  "Mittwoch", "uhrzeit": "18:00 - 20:00", "zielgruppe": "Jugendliche und Erwachsene", "ort": "IGS / Halle A", "trainer": "Emre Tahtali"},
{'wochentag':  "Donnerstag", "uhrzeit": "16:30 - 18:00", "zielgruppe": "Prüfungsvorbereitung (nach Absprache)", "ort": "Turnhalle Stelingen", "trainer": "Arne Reckhaus"},
        {'wochentag':  "Freitag", "uhrzeit": "20:00 - 22:00", "zielgruppe": "Jugendliche und Erwachsene", "ort": "IGS / Halle A", "trainer": "Falk Oberwetter & Tim Baake"}
      ],

      type: 'week',
      types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      weekdays: [
        { text: 'Sontag - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],

    }
  },
  computed: {
    trainingsplanAugmented() {
      return this.traningsplan.map((row, idx, arr) => {
        const isFirstOfDay = idx === 0 || row.wochentag !== arr[idx - 1].wochentag
        return {...row, isFirstOfDay}
      })
    }
  },
  methods: {
    task(b64){
      if (!b64) return;
      try {
        const decoded = atob(b64);
        window.location.href = decoded
      } catch (e) {
        console.error("Fehler beim Decodieren der Base64-Zeichenfolge:", e);
      }
    },
    tooltipFor(ort){
      if(ort === "IGS / Halle A") return "IGS Garbsen / Zufahrt über Kastendamm"
      return "In Google Maps öffnen"
    },
    openLocation(ort){
      if(ort === "IGS / Halle A"){
        window.open('https://maps.app.goo.gl/VW3he6pKvWUYMSEb9', '_blank')
      }
      else if(ort === "Turnhalle Stelingen"){
        window.open('https://maps.app.goo.gl/uBishaw3JKgN3jeK6', '_blank')
      }
    },
    getEvents ({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        })
      }

      this.events = events
    },
    getEventColor (event) {
      return event.color
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
  },
}
</script>

<style scoped>

</style>